var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":""}},[_c('div',{staticClass:"text-xs-center",domProps:{"innerHTML":_vm._s(_vm.error)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }